import React from "react";

export default function ArrowDoubleIcon({
	color = "#1A1C21",
	width = 16,
	height = 16,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_4483_44952)">
				<path
					d="M5.2513 3.41675V0.666748L0.667969 4.33341L5.2513 8.00008V5.25008H12.5846C13.0906 5.25008 13.5013 4.83941 13.5013 4.33341C13.5013 3.82741 13.0906 3.41675 12.5846 3.41675H5.2513Z"
					fill={color}
				/>
				<path
					d="M10.752 10.7501H3.41862C2.91262 10.7501 2.50195 11.1608 2.50195 11.6668C2.50195 12.1728 2.91262 12.5835 3.41862 12.5835H10.752V15.3335L15.3353 11.6668L10.752 8.00012V10.7501Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_4483_44952">
					<rect
						width="14.6667"
						height="14.6667"
						fill="white"
						transform="translate(0.666016 0.666626)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
